import React from 'react';
import { NavLink } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { showVerificationAccess } from '../../data/guide/home';
import { isStaffView } from '../../utils/staffMode';

/** Acceso al panel técnico. Solo aparece en la vista previa de Magic Patterns, nunca en el sitio publicado. */
export function VerificationAccessLink({
  size = 'sm'
}: {
  size?: 'sm' | 'lg';
}) {
  if (!showVerificationAccess || !isStaffView) return null;
  return <NavLink to="/guia/verificacion" className={({
    isActive
  }) => `flex items-center gap-2.5 rounded-xl border border-dashed px-3 ${size === 'lg' ? 'py-3' : 'py-2.5'} text-sm transition-colors duration-150 ${isActive ? 'border-amber-300/60 bg-amber-300/10 text-amber-100' : 'border-amber-300/30 text-amber-100/80 hover:border-amber-300/60 hover:text-amber-100'}`} data-id="element-904" data-mp="3ik77unmt2ow6">
      <ShieldCheck className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-905" data-mp="55azjq1i93p3" />
      <span className="flex-1 leading-snug" data-id="element-906" data-mp="b6rf3gi6pmf">Verificación de datos</span>
      <span className="rounded-full bg-amber-300/15 px-2 py-0.5 text-[10px] font-semibold" data-id="element-907" data-mp="1ho79b9awknfl">Solo staff</span>
    </NavLink>;
}